"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rejectIpDiscountSchema = exports.approveIpDiscountSchema = exports.requestIpDiscountSchema = exports.ipDiscountStatusEnum = exports.ipDiscountTypeEnum = void 0;
const zod_1 = require("zod");
/** IP discount contracts — ADR-085 Phase 7. */
exports.ipDiscountTypeEnum = zod_1.z.enum([
    'LINE', 'BILL', 'EMPLOYEE', 'DOCTOR', 'CORPORATE_COURTESY', 'MANAGEMENT',
    'CHARITY', 'SPECIAL_APPROVAL', 'GOVERNMENT_SCHEME', 'PROMOTIONAL',
]);
exports.ipDiscountStatusEnum = zod_1.z.enum([
    'REQUESTED', 'PENDING', 'APPROVED', 'PARTIALLY_APPROVED', 'REJECTED', 'CANCELLED',
]);
/**
 * Amount OR percentage, never both — two sources of truth for one number is how
 * they diverge. Enforced by the schema so the API cannot express the ambiguity.
 */
exports.requestIpDiscountSchema = zod_1.z
    .object({
    /** Null/omitted = a BILL-level discount across the stay. */
    chargeLedgerId: zod_1.z.string().uuid().nullish(),
    discountType: exports.ipDiscountTypeEnum,
    /** A coded reason, never free text. `remarks` carries the specifics. */
    reasonId: zod_1.z.string().uuid(),
    requestedAmount: zod_1.z.number().int().positive().optional(),
    requestedPercentBasisPoints: zod_1.z.number().int().positive().max(10_000).optional(),
    remarks: zod_1.z.string().max(1000).optional(),
})
    .refine((v) => (v.requestedAmount == null) !== (v.requestedPercentBasisPoints == null), {
    message: 'Supply either requestedAmount or requestedPercentBasisPoints, not both and not neither',
    path: ['requestedAmount'],
});
exports.approveIpDiscountSchema = zod_1.z.object({
    approvedAmount: zod_1.z.number().int().positive(),
    /** Which authority is granting it. The matrix bounds how much this level may approve. */
    levelCode: zod_1.z.string().min(1).max(30),
    decisionReason: zod_1.z.string().max(1000).optional(),
});
exports.rejectIpDiscountSchema = zod_1.z.object({
    reason: zod_1.z.string().min(1).max(1000),
    levelCode: zod_1.z.string().max(30).optional(),
});
//# sourceMappingURL=ip-discount.schema.js.map